<template>
    <div class="product-page">
      <el-row>
              <el-col>
       <public-tem :mainTabs="false"
                    class="product-1"
                    v-if="active === 0">
        <div slot="topShow" >
          <div class="img-1">
          <span class="txt">财政产品</span>
          </div>
        </div>
        <div slot="mainBody">
          <div class="container-1">
            <el-row>
              <el-col>
          <div class="box1-3">
              <span class="txt-3"><router-link to="/product-detail/1">项目库管理系统</router-link></span>
              <span class="txt-3"><router-link to="/product-detail/2">中期财政规划系统</router-link></span>
              <span class="txt-3"><router-link to="/product-detail/3">预算编制管理系统</router-link></span>
              <span class="txt-3"><router-link to="/product-detail/4">预算编制调整系统</router-link></span>
              <span class="txt-3"><router-link to="/product-detail/5">预算执行管理系统</router-link></span>
          </div>
          </el-col>
          <el-col>
          <div class="box1-3">
            <span class="txt-3"><router-link to="/product-detail/6">预算绩效管理系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/11">资产管理系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/7">财务管理系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/13">专项资金管理系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/15">会计人员网上办事系统</router-link></span>
          </div>
          </el-col>
          <el-col>
          <div class="box1-3">
            <span class="txt-3"><router-link to="/product-detail/12">基建资金管理系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/14">人事工资管理系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/16">三资监管系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/17">银企互联系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/10">财政大数据应用系统</router-link></span>
          </div>
          </el-col>
          <el-col>
          <div class="box1-3">
            <span class="txt-3"><router-link to="/product-detail/9">一企一情管理系统</router-link></span>
            <span class="txt-3"><router-link to="/product-detail/8">政府采购管理系统</router-link></span>
          </div>
          </el-col>
          </el-row>
        </div>
        </div>
    </public-tem>
    </el-col>
            </el-row>

      <el-row>
              <el-col>
     <public-tem :mainTabs="false"
                  class="product-2"
                  v-if="active === 1" >
        <div slot="topShow" >
          <div class="img-1">
          <span class="txt">单位内控产品</span>
          </div>
        </div>
        <div slot="mainBody" style="height:800px">
          <div class="container-2">
            <div class="box1-3">
                <span class="txt-3"><router-link to="/solution/1">项目管理系统</router-link></span>
                <span class="txt-3"><router-link to="/solution/2">预算编制管理系统</router-link></span>
                <span class="txt-3"><router-link to="/solution/3">资产管理系统</router-link></span>
                <span class="txt-3"><router-link to="/solution/4">预算绩效管理系统</router-link></span>
                <span class="txt-3"><router-link to="/solution/5">指标管理系统</router-link></span>
            </div>
            <div class="box1-3">
              <span class="txt-3"><router-link to="/solution/6">网上报账系统</router-link></span>
              <span class="txt-3"><router-link to="/solution/7">财务管理系统</router-link></span>
              <span class="txt-3"><router-link to="/solution/8">采购管理系统</router-link></span>
              <span class="txt-3"><router-link to="/solution/9">合同管理系统</router-link></span>
              <span class="txt-3"><router-link to="/solution/10">人事工资管理系统</router-link></span>
            </div>
            <div class="box1-4">
              <span class="txt-3"><router-link to="/solution/11">基建资金管理系统</router-link></span>
              <span class="txt-3"><router-link to="/solution/12">文档管理系统</router-link></span>
              <span class="txt-3"><router-link to="/solution/13">移动非税收入缴费系统</router-link></span>
            </div>
          </div>
        </div>
       </public-tem>
       </el-col>
            </el-row>
    </div>
</template>

<script>
import publicTem from "@/components/publicTemplate/index";
export default {
  name: "index",
  components: {
    publicTem
  },
  data() {
    return {
      // advList: [],
      active: 0
    };
  },
  watch: {
    $route() {
      this.active = +this.$route.params.id - 1;
      this.$nextTick(() => {
        document.documentElement.scrollTop = +this.$route.params.top;
        document.body.scrollTop = +this.$route.params.top;
      });
    }
  },
  created() {
    this.active = +this.$route.params.id - 1;
  },
  methods: {
    onChange(i) {
      this.active = i;
      this.$router.push({
        name: "product",
        params: {
          id: i + 1,
          top:
            document.body.scrollTop === 0
              ? document.documentElement.scrollTop
              : document.body.scrollTop
        }
      });
    }
    // getAdv() {
    //   axios.get('adv/7093/getAdv', {
    //     params: {
    //       type: '1'
    //     }
    //   }).then(({ data }) => {
    //     if(data.code === '1') {
    //       // console.log(data.data)
    //       this.advList = data.data.list
    //       const that = this
    //       this.$nextTick(() => {
    //         const con = document.querySelector('#swiper .swiper-container')
    //         new Swiper(con, {
    //           loop: true,
    //           autoplay: {
    //             delay: 3000
    //           },
    //           navigation: {
    //             nextEl: '.swiper-button-next',
    //             prevEl: '.swiper-button-prev',
    //           },
    //           on: {
    //             slideChange() {
    //               that.$nextTick(() => {
    //                 try {
    //                   const active = con.querySelector('.swiper-slide-active')
    //                   const len = that.advList.length
    //                   const width = (+active.dataset.swiperSlideIndex) / len
    //                   that.$refs.progress.style.width = 1 / len * 100 + '%'
    //                   that.$refs.progress.style.left = width * 100 + '%'
    //                 }catch (e) {
    //                 }
    //               })
    //             }
    //           }
    //         })
    //       })
    //     }
    //   })
    // }
  },
  created() {
    // this.getAdv()
    // this.getTrend()
  },
  mounted() {}
};
</script>

<style scoped>
</style>
